import { ClientUpdateHandler, ClientUpdateRequestType, Collection } from "@mcleod/core";
import { MainPageAccessor, Snackbar } from "@mcleod/components";

/**
 * This class performs the actions necessary to allow the current tab to reflect temporary license changes made for the
 * user.
 */
export class TemporaryLicenseChangeHandler extends ClientUpdateHandler {
    override get type(): ClientUpdateRequestType {
        return ClientUpdateRequestType.TEMPORARY_LICENSE_CHANGE;
    }

    override handle(_addlInputs?: Collection<any>) {
        this.displaySnackbar();
        this.reloadAfterDelay();
    }

    private displaySnackbar() {
        Snackbar.showDownloadSnackbar("Page Will Reload",
            "Please wait while the licensing changes take effect...",
            { persist: true, id: "licensingReload", targetPanel: MainPageAccessor.router }
        );
    }

    private reloadAfterDelay() {
        setTimeout(() => {
            window.location.reload();
        }, 2500);
    }
}
